import * as React from "react";
function CloseCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0zM12 3.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47 15.88a.409.409 0 01-.29-.119l-3.182-3.182-3.182 3.182a.409.409 0 11-.58-.578L11.422 12 8.238 8.819a.41.41 0 01.58-.579l3.181 3.182 3.182-3.182a.407.407 0 01.578 0 .41.41 0 010 .579L12.578 12l3.181 3.182a.41.41 0 01-.29.699z"
  }));
}
const ForwardRef = React.forwardRef(CloseCircleIcon);
export default ForwardRef;